﻿import {ValidationMessage} from '../validationMessage';
import {ValidationMessageType} from '../validationMessageType';
import {MandatoryDataMissing} from '../validationConstants';
import {ValidateResult} from '../validateResult';
import {IValidator} from './iValidator';

export class RequiredValidator implements IValidator{
    type: string = 'text';
    defaultValue:string;

    validate(value: any, propertyName, propertydisplayName,errorMessage): ValidateResult {
        let result = new ValidateResult();
        if ((this.type != 'select' && value) || (this.type =='select' && value!=this.defaultValue)) {
            return result;
        }
        let vm = new ValidationMessage();
        //if (typeof errorMessage == 'undefined' || errorMessage==null  || errorMessage == '') {
            vm.message = propertydisplayName + ' is required';
        //} else {
        //    vm.message = errorMessage;
        //}
        
        vm.propertyName = propertyName;
        vm.messageType = ValidationMessageType.Error;
        result.validationMessage = vm;
        return result;
    }
}   